import { createStandardAction } from 'typesafe-actions';

import { FetchKeysStoreKey } from '../reducers/createFetchKeysReducer';

const updateFetchKeyDelayed = createStandardAction('updateFetchKeyDelayed')<FetchKeysStoreKey>();

export default updateFetchKeyDelayed;
